import React from 'react';
import KeyboardArrowDownRounded from '@material-ui/icons/KeyboardArrowDownRounded';
import Collapse from '@material-ui/core/Collapse';

import { withResizer , withTranslations } from '../../../../HoCs';
import Component from '../../../Component';
import styles from './styles';

class Help extends Component {

    styles = styles;
    
    render = () => <div style={{ ...this.gs('container'), ...this.props.style }}>
        <div style={this.gs('heading')}>{this.guc('FAQs')}</div>
        <Accordion title={this.guc('how_to_get')} gs={this.gs}>
            <div style={this.gs('accordion_font')}>{this.guc('follow_these_steps')}</div>
            <ol style={{ paddingLeft: 15 }}>
                <li style={this.gs('accordion_font')}>{this.guc('click_on_add')}</li>
                <li style={this.gs('accordion_font')}>{this.guc('fill_details_manually')}</li>
                <li style={this.gs('accordion_font')}>{this.guc('submit_details_and')}</li>
            </ol>
        </Accordion>
        <Accordion title={this.guc('can_i_onboard') + '?'} gs={this.gs}>
            {this.guc('yes_click_on')}
        </Accordion>
        <Accordion title={this.guc('how_many_bookings') + '?'} gs={this.gs}>
            {this.guc('you_will_get')}
        </Accordion>
        <Accordion title={this.guc('i_am_already') + '?'} gs={this.gs}>
            {this.guc('yes_click_on_other')}
        </Accordion>
        <Accordion title={this.guc('what_are_the') + '?'} gs={this.gs}>
            {this.guc('our_representative_will')}
        </Accordion>
        <Accordion title={this.guc('how_are_the') + '?'} gs={this.gs}>
            {this.guc('the_bookings_and')}
        </Accordion>
    </div>;

}

export default withTranslations(withResizer(Help));

const Accordion = React.memo(({ title, children, gs }) => {

    const [open, setOpen] = React.useState(false);

    return <div style={gs('accordion_container')}>
        <div style={gs('accordion_header')} onClick={() => setOpen(!open)}>
            <div style={gs('accordion_title')}>{title}</div>
            <KeyboardArrowDownRounded style={{ ...gs('accordion_arrow'), ...(open ? gs('rotated') : {}) }} />
        </div>
        <Collapse in={open}>
            <div style={gs('accordion_content')}>{children}</div>
        </Collapse>
    </div>;

});